//import React from "react";
import Typography from '@mui/material/Typography';
import CardDisclaimer from '../../../../../components/CockpitCards/CardDisclaimer';


export default function DisclaimerCardpgx() {

return(
<>
<CardDisclaimer

  headline = "GENERAL DISCLAIMER" 
  subtext = {
     <Typography>  
         
        The genetic information presented here is intended for informational and educational puroses only. It is not a substitute for professional medical advice, 
        diagnosis, or treatment. Users should alsways consult with a qualified healthcare provider or verified genetic counselor regarding any questions or concerns 
        related to genetic findings. While careful efforts have been made to ensure accuracy and completeness, no guarantee is made that all data presented is 
        free from errors or omissions. Interpretations of genetic variants, including pathogenicity, may evolve over time as new research emerges.
  <br /><br />
Liability: speak23 assumes no responsibility for any injury to person or damage to persons or property arising out of, or related to any use of speak23, 
or for any errors or omissions. The user recognizes that PharmCAT is a research tool and that they are using PharmCAT at their own risk.
  <br /><br />
For the full description of potential benefits and risks, additional considerations (general and specific to gene-drug pairs), 
limitations, information about respective gene nomenclature systems, potential drug-drug interactions and clinical factors to consider, 
please see individual CPIC guidelines at (cpicpgx.org).
  <br /><br />
"CPIC guidelines reflect expert consensus based on clinical evidence and peer-reviewed literature available at the time they are written and 
are intended only to assist clinicians in decision-making and to identify questions for further research. 
New evidence may have emerged since the time a guideline was submitted for publication. 
Guidelines are limited in scope and are not applicable to interventions or diseases not specifically identified. 
Guidelines do not account for all individual variations among patients and cannot be considered inclusive of all proper methods 
of care or exclusive of other treatments. It remains the responsibility of the health-care provider to determine the best course of 
treatment for a patient. Adherence to any guidelines is voluntary, with the ultimate determination regarding its application to be made 
solely by the clinician and the patient. CPIC assumes no responsibility for any injury to persons or damage to persons or property arising out 
of or related to any use of CPIC's guidelines, or for any errors or omissions." (PMID: 27997040)

  <br /><br />

"Caveats: appropriate use and/or potential misuse of genetic tests. The application of genotype-based dosing is most appropriate 
when initiating therapy with a tricyclic. Obtaining a pharmacogenetic test after months of drug therapy may be less helpful in some instances, 
as the drug dose may have already been adjusted based on plasma concentrations, response, or side effects. Similar to all diagnostic tests, 
genetic tests are one of several pieces of clinical information that should be considered before initiating drug therapy." (PMID: 27997040)
    <br /><br />
  CPIC guidelines reflect the alleles/genotypes known and considered by the guideline authors for inclusion by the time of publication, 
  however they may be updated online at cpicpgx.org and in the CPIC database in between publications. Additional alleles and/or more extensive 
  allele definitions might exist by the representative gene nomenclatures for various genes.
  </Typography>
  }
/>
</> 
)
}

